// https://blog.corsego.com/action-text-embed-youtube
import Trix from "trix";

class EmbedController {
  constructor(element) {
    this.patterns = [
      /^https:\/\/([^\.]+\.)?youtube\.com\/watch\?v=(.*)/,
      /^https:\/\/([^\.]+\.)?instagram\.com\/reel\/([^\/]+)\//,
    ];
    // the ordering of providers must follow the ordering of the patterns above
    this.providers = ["youtube", "instagram"];

    this.element = element;
    this.editor = element.editor;
    this.toolbar = element.toolbarElement;
    this.hrefElement = this.toolbar.querySelector(
      "[data-trix-input][name='href']",
    );
    this.embedContainerElement = this.toolbar.querySelector(
      "[data-behavior='embed_container']",
    );
    this.embedElement = this.toolbar.querySelector(
      "[data-behavior='embed_url']",
    );

    this.reset();
    this.installEventHandlers();
  }

  installEventHandlers() {
    this.hrefElement.addEventListener("input", this.didInput.bind(this));
    this.hrefElement.addEventListener("focusin", this.didInput.bind(this));
    this.embedElement.addEventListener("click", this.embed.bind(this));
  }

  didInput(event) {
    const value = event.target.value.trim();
    let matches = null;
    let provider = null;

    for (let i = 0; i < this.patterns.length; i++) {
      matches = value.match(this.patterns[i]);
      provider = this.providers[i];

      if (matches != null) {
        break;
      }
    }

    // When patterns are loaded, we can just fetch the embed code
    if (matches != null) {
      const id = matches[2].split("&")[0];
      this.fetch(id, provider);

      // No embed code, just reset the form
    } else {
      this.reset();
    }
  }

  fetch(value, provider) {
    fetch(`/videos/${encodeURIComponent(value)}/${provider}`)
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
      })
      .then((json) => {
        if (json) {
          this.showEmbed(json);
        } else {
          this.reset();
        }
      });
  }

  embed(event) {
    if (this.currentEmbed == null) {
      return;
    }

    const attachment = new Trix.Attachment(this.currentEmbed);
    this.editor.insertAttachment(attachment);
    this.element.focus();
  }

  showEmbed(embed) {
    this.currentEmbed = embed;
    this.embedContainerElement.style.display = "block";
  }

  reset() {
    this.embedContainerElement.style.display = "none";
    this.currentEmbed = null;
  }
}

document.addEventListener("trix-initialize", (event) => {
  new EmbedController(event.target);
});
